import Image from 'next/legacy/image'

import { useLocale } from '@/context/localeContext'

import loki from 'public/ppe-icons/apron.svg'
import boots from 'public/ppe-icons/boots.svg'
import dustMask from 'public/ppe-icons/dust-mask.svg'
import earMuffs from 'public/ppe-icons/ear-muffs.svg'
import faceShield from 'public/ppe-icons/face-shield.svg'
import gloves from 'public/ppe-icons/gloves.svg'
import goggles from 'public/ppe-icons/goggles.svg'
import gumBoots from 'public/ppe-icons/gum-boots.svg'
import hardHat from 'public/ppe-icons/hardhat.svg'
import longSleeves from 'public/ppe-icons/long-sleeves.svg'
import vest from 'public/ppe-icons/vest.svg'
import weldMask from 'public/ppe-icons/weld-mask.svg'

const ICON_SIZE = 60

const makeIcon = (src: string, alt: string) => ({
  label: alt,
  icon: (
    <Image width={ICON_SIZE} height={ICON_SIZE} src={src} alt={alt} priority />
  ),
})

export const ppelist = (t: ReturnType<typeof useLocale>['t']) => [
  makeIcon(boots.src, t('swmsBuilder:ppe.steelCappedBoots')),
  makeIcon(hardHat.src, t('swmsBuilder:ppe.hardHat')),
  makeIcon(vest.src, t('swmsBuilder:ppe.hiVisVest')),
  makeIcon(goggles.src, t('swmsBuilder:ppe.eyeProtection')),
  makeIcon(faceShield.src, t('swmsBuilder:ppe.faceShield')),
  makeIcon(loki.src, t('swmsBuilder:ppe.harnessAndLanyard')),
  makeIcon(earMuffs.src, t('swmsBuilder:ppe.hearingProtection')),
  makeIcon(weldMask.src, t('swmsBuilder:ppe.weldMask')),
  makeIcon(longSleeves.src, t('swmsBuilder:ppe.longSleevesPants')),
  makeIcon(gloves.src, t('swmsBuilder:ppe.gloves')),
  makeIcon(dustMask.src, t('swmsBuilder:ppe.dustMask')),
  makeIcon(gumBoots.src, t('swmsBuilder:ppe.waterproofClothing')),
]
